<template>

  <v-dialog
    ref="dialog1"
    v-model="modal1"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="computedDate"
        :label="label"
        prepend-icon="mdi-calendar"
        :clearable="clearable"
        :disabled="disabled"
        readonly
        v-bind="attrs"
        v-on="on"
        style="
                  margin: 0 auto;
                  width: 350px;"


          @click:clear="callItBack()"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      color="pink"
      scrollable
      locale="de-de"
      :first-day-of-week="1"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="pink"
        @click="modal1 = false"
      >
        Abbrechen
      </v-btn>
      <v-btn
        text
        color="pink"
        @click="$refs.dialog1.save(date)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>

</template>

<script>
export default {
  name: "DialogDate",

  data() {
    return {

      modal1: false,
      date: null,    
    
    }
  },

  created() {
    // Initialize date from value prop if it exists
    if (this.value) {
      try {
        // Parse the input value (which should be DD.MM.YYYY format)
        this.date = this.$moment(this.value, "DD.MM.YYYY").format("YYYY-MM-DD");
      } catch (error) {
        console.error("Error parsing initial date:", error);
        this.date = null;
      }
    }
    
    // Fallback to initial_date if value prop isn't set but initial_date is
    else if (this.initial_date) {
      try {
        this.date = this.$moment(this.initial_date, "DD.MM.YYYY").format("YYYY-MM-DD");
      } catch (error) {
        console.error("Error parsing initial_date:", error);
        this.date = null;
      }
    }
  },

  methods: {
    callItBack(){
      this.date = ""
      // this.$emit('input', "")
    }
  },

  watch: {
    value(newVal) {
      if (newVal && newVal !== this.computedDate) {
        try {
          this.date = this.$moment(newVal, "DD.MM.YYYY").format("YYYY-MM-DD");
        } catch (error) {
          console.error("Error parsing new value:", error);
        }
      }
    },
    
    initial_date(newVal) {
      if (newVal) {
        try {
          this.date = this.$moment(newVal, "DD.MM.YYYY").format("YYYY-MM-DD");
        } catch (error) {
          console.error("Error parsing new initial_date:", error);
        }
      }
    }
  },

  computed: {
    computedDate() {
     
      if (!this.date || this.date === "" || this.$moment(this.date).format("YYYY-MM-DD") === "Invalid date") {
        this.$emit('input', "");
        return "";
      }

      // Format and emit the date
      const formattedDate = this.$moment(this.date, "YYYY-MM-DD").format("DD.MM.YYYY");
      this.$emit('input', formattedDate);
      return formattedDate;
    },
  },

  props: {
    // Add the value prop for v-model to work properly
    value: {
      type: String,
      default: null
    },
    
    initial_date: {
      type: String,
      default: null,
    },

    label: {
      type: String,
      default: "Datum"
    },

    clearable: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  model: {
    prop: 'value',
    event: 'input'
  },
}
</script>
<style scoped>

</style>